import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../shared/helpers/icons';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { StudentSsidComponent } from '../components/student-ssid/student-ssid.component';
import { StudentInfoFormComponent } from '../components/student-info-form/student-info-form.component';
import { StudentService } from '../../shared/services/student.service';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { StudentInfoReviewComponent } from "../components/student-info-review/student-info-review.component";
import { UserDataService } from '../../shared/services/auth/userData.service';
import { IStudentInfo } from '../../shared/models/student';
import { StudentCasesComponent } from "../components/student-cases/student-cases.component";
import { IAssessCaseCreate } from '../../shared/models/assessCase';
import { AssessCaseService } from '../../shared/services/assessCase.service';
import { PopupMessageComponent } from '../components/popup-message/popup-message.component';
import { AssessAssistantComponent } from '../components/assess-assistant/assess-assistant.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterOutlet,
    StudentSsidComponent,
    StudentInfoFormComponent,
    SpinnerComponent,
    StudentInfoReviewComponent,
    StudentCasesComponent,
    PopupMessageComponent,
    AssessAssistantComponent
],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit{
  icons = Icons;
  
  pages = [
    { name: 'Cases',
      route: 'cases'
    },
    { name: 'My Tasks',
      route: 'my-tasks'
    }
  ];
  selectedPage = this.pages[0];
  buildingId: string | null = null;
  regionId: string | null = null;
  studentSSID: string = '';
  currentStudent: IStudentInfo | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;
  
  showStudentSSIDForm: boolean = false;
  showStudentInfoForm: boolean = false;
  showStudentInfoReview: boolean = false;
  showStudentCases: boolean = false;
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private studentService: StudentService,
    private assessCaseService: AssessCaseService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.buildingId = this.userDataService.getBuildingId();
    this.regionId = this.userDataService.getRegionId();

    // get the current route
    const currentRoute = this.router.url.split('/')[1];
    this.selectedPage = this.pages.find(page => page.route === currentRoute) || this.pages[0];
  }
  
  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }

  handleOpenModal(modalType: string): void {
    if (modalType === 'student ssid') {
      this.showStudentSSIDForm = true;
    } else if (modalType === 'student info') {
      this.showStudentInfoForm = true;
    } else if (modalType === 'student info review') {
      this.showStudentInfoReview = true;
    } else if (modalType === 'student cases') {
      this.showStudentCases = true;
    }
  }

  handleCloseModal(modalType: string): void {
    if (modalType === 'student ssid') {
      this.showStudentSSIDForm = false;
    } else if (modalType === 'student info') {
      this.showStudentInfoForm = false;
    } else if (modalType === 'student info review and continue') {
      this.showStudentInfoReview = false;
      this.showStudentCases = true;
    } else if (modalType === 'student info review') {
      this.showStudentInfoReview = false;
    }
    else if (modalType === 'student cases') {
      this.showStudentCases = false;
    }
  }

  handleSubmitStudentSSID(data: {student_identifier: string}): void {
    if (this.buildingId && this.regionId) {      
      this.loading = true;
      this.showStudentSSIDForm = false;
      const fullData = { ...data, building_id: this.buildingId };
      this.studentService.findStudentBySsid(this.regionId, fullData).subscribe({
        next: (response) => {
          if (response.found === false) {
            this.loading = false;
            this.studentSSID = data.student_identifier;
            this.handleOpenModal('student info');
            return;
          } else if (response.found === true) {
            this.loading = false;
            this.currentStudent = response.student;
            this.handleOpenModal('student info review');
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error fetching student info:', error);
          this.messageModal = 'unsuccess'
          this.popupMessage = error.message;
        }
      });
    } else {
      return
    }
  }

  handleCreateNewCaseForExistingStudent(data: {student_identifier: string}): void {
    if (this.buildingId) {
      this.loading = true;
      this.showStudentCases = false;
      const formValues: IAssessCaseCreate = {
        student_identifier: data.student_identifier,
        building_id: Number(this.buildingId),
      };
      this.assessCaseService.createNewCaseForExistingStudent(formValues).subscribe({
        next: (response) => {
          this.loading = false;       
          this.router.navigate(['/evaluations/form/' + response.case_id]);
        },
        error: (error) => {
          this.loading = false;
          console.error('Error creating new case:', error);
          this.messageModal = 'unsuccess'
          this.popupMessage = error.message;
        }
      });
    }
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }

}
